
    var riot = require('riot')
    //src: starling/src/tags/menu/buttons/menu-button-create-relationship.html
riot.tag2('menu-button-create-relationship',
  '<svg class="bulk-actions-menu-item_icon"> <use xlink:href="#add-relationship-icon"></use> </svg>',
  '',
  'class="bulk-actions-menu-item" data-tip="{getLabel()}" data-track="Toolbar" data-track-action="{getLabel()}" data-track-label="Selection" onclick="{addRelationship}"', function(opts) {
'use strict';

var _this = this;

var _relationshipUi = require('lib/relationship-ui');

var _opts = opts,
    canvas = _opts.canvas;

this.isSingleCard = function () {
  return canvas.getSelectedNodes().length === 1;
};

this.getSelectedNode = function () {
  return canvas.getSelectedNodes()[0];
};

this.getLabel = function () {
  return _this.isSingleCard() ? 'Create a relationship line' : 'Connect with relationship line';
};

this.addRelationship = function (event) {
  var nodes = canvas.getSelectedNodes();

  event.stopPropagation();

  if (_this.isSingleCard()) {
    _relationshipUi.rui.startCreationFromClick();
  } else {
    _relationshipUi.rui.createLinksToNodes(nodes[0], [nodes[1]]);
  }
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('menu-button-create-relationship')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/buttons/menu-button-create-relationship.html
// module id = 722
// module chunks = 0